import { Code2, Rocket, ShoppingBag, Layers, Gauge, ShieldCheck } from "lucide-react";

export const SERVICES = [
  {
    id: "web-apps",
    icon: Code2,
    tag: "Build",
    title: "Custom Web Applications",
    summary: "Portals, dashboards and internal tools engineered around how your business actually runs, not around a template.",
    deliverables: ["Discovery & technical scoping", "React front end + API back end", "Role-based access & auth", "Docs and handoff"],
  },
  {
    id: "marketing-sites",
    icon: Rocket,
    tag: "Grow",
    title: "High-Converting Marketing Sites",
    summary: "Fast, search-ready business websites with sharp messaging and clear calls to action that turn visitors into inquiries.",
    deliverables: ["Copy & page structure", "Responsive custom design", "Lead capture + email routing", "Analytics setup"],
  },
  {
    id: "ecommerce",
    icon: ShoppingBag,
    tag: "Sell",
    title: "E-commerce Builds",
    summary: "Storefronts that load fast, check out cleanly and plug into the payment, shipping and inventory tools you already use.",
    deliverables: ["Catalog & product pages", "Checkout & payments", "Shipping / tax rules", "Conversion tuning"],
  },
  {
    id: "saas",
    icon: Layers,
    tag: "Launch",
    title: "SaaS & Product Development",
    summary: "From MVP to paying customers: we design, build and ship full-stack products with subscriptions, onboarding and admin.",
    deliverables: ["MVP roadmap", "Full-stack build", "Billing & subscriptions", "Iterative releases"],
  },
  {
    id: "performance",
    icon: Gauge,
    tag: "Optimize",
    title: "Performance, SEO & Core Web Vitals",
    summary: "We audit and rebuild slow sites so they rank, load in under two seconds and stop leaking visitors on mobile.",
    deliverables: ["Speed & SEO audit", "Core Web Vitals fixes", "Technical SEO & schema", "Before/after report"],
  },
  {
    id: "care",
    icon: ShieldCheck,
    tag: "Maintain",
    title: "Hosting, Care & Support Plans",
    summary: "Managed hosting, updates, backups, uptime monitoring and a direct line to the developer who built your site.",
    deliverables: ["Managed hosting", "Security & updates", "Daily backups", "Monthly content hours"],
  },
];
